<template>
  <UiVersionToast
    v-if="newUiEnabled"
    :visible="newVersionAvailable"
    @reload="loadNewVersion"
    @close="onCloseClick"
  />

  <div v-else-if="newVersionAvailable" class="version-checker">
    <div class="version-checker-content mb-2">
      <UiIcon fa="fa fa-info-circle" />

      <h6>{{ $t("New version of application is available.") }}</h6>
    </div>

    <div class="text-end">
      <b-button variant="primary" size="sm" @click="loadNewVersion">
        <UiIcon fa="fa fa-sync-alt me-1" /> {{ $t("Load new version") }}
      </b-button>
    </div>

    <div class="version-checker-close" @click="onCloseClick">
      <UiIcon fa="fa fa-times" />
    </div>
  </div>
</template>

<script>
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";
import UiVersionToast from "@/components/newUi/toast/UiVersionToast.vue";

export default {
  name: "VersionChecker",

  components: { UiVersionToast },

  setup() {
    return { newUiEnabled: useNewUiEnabled() };
  },

  data() {
    return {
      hidden: false,
    };
  },

  computed: {
    newVersionAvailable() {
      const currentVersion = this.$store.getters.currentBuildVersion;
      const availableVersion = this.$store.getters.availableBuildVersion;

      if (
        currentVersion === null ||
        availableVersion === null ||
        currentVersion === availableVersion
      ) {
        return false;
      }

      return !this.hidden;
    },
  },

  async mounted() {
    await this.$store.dispatch("getBuildVersion");
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },

  beforeUnmount() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },

  methods: {
    onVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.$store.dispatch("getBuildVersion");
      }
    },

    onCloseClick() {
      this.hidden = true;
    },

    loadNewVersion() {
      window.location.reload();
    },
  },
};
</script>
